import * as React from 'react';
export const creditmutuelSvg = React.forwardRef(function creditmutuelSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#DC0028',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M23.6 14.02h-.02l.05.18.02.17.02.37-.02.33-.07.37-.06.35-.13.32-.14.35-.17.31-.21.31-.23.26-.25.26-.23.17-.3.2-.31.2-.34.15-.33.11-.36.09-.35.06h-.11l-.17-.24-.12-.13-.25-.31-.27-.26-.32-.24-.31-.22-.34-.19-.35-.18-.38-.13-.46-.13-.4-.06-.38-.03-.15-.02-.08-.21-.12-.33-.11-.37-.04-.33-.04-.37.02-.37.04-.35.08-.35.09-.35.16-.33.17-.3.21-.28.23-.29.25-.26.3-.24.29-.19.34-.2.33-.13.34-.13.35-.09.38-.07h.54l.36.03.36.06.35.09.34.13.34.15.29.2.31.22.04.02L18.83 6l-5.47.04-3.33 5.61.23-.16.33-.17.34-.13.35-.13.36-.07.38-.06.35-.03.38.03.36.06.35.07.36.13.33.13.32.17.29.2.27.22.26.26.23.28.06.07-.09.19-.14.35-.15.37-.08.37-.06.38-.05.39v.37l.05.39.06.39.1.37.17.46.17.35.02.07-.15.19-.12.13-.23.24-.28.24-.29.22-.31.18-.34.15-.31.13-.36.07-.38.06-.33.02-.38-.02-.36-.04-.35-.09-.34-.11-.48-.22-.31-.17-.3-.2-.27-.24-.25-.26-.23-.28-.21-.31-.17-.3-.17-.4-.08-.32-.08-.35-.03-.37-.01-.35.01-.2v-.06l-3.35 5.73 2.62 4.71 7.19-.02-.21-.07-.17-.06-.33-.15-.32-.18-.29-.22-.27-.24-.25-.26-.24-.28-.18-.31-.19-.3-.13-.35-.1-.35-.09-.46-.02-.37.02-.35.02-.35.07-.35.1-.35.15-.34.04-.09.23-.02h.19l.38-.07.39-.11.36-.1.36-.16.35-.2.32-.19.31-.24.4-.37.25-.28.23-.31.07-.07h.04l.21.03.33.06.38.09.34.13.33.15.31.2.28.21.27.23.23.26.23.28.19.31.17.32.12.33.11.35.06.35.04.34v.29l-.02.37-.06.33-.11.35-.12.34-.15.31-.23.41-.23.26-.21.27-.29.24-.28.21-.31.2-.33.15-.34.13-.09.03h6.92L27 19.76l-3.4-5.74Z',
      fill: '#fff',
    }),
  );
});
creditmutuelSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var creditmutuel = {
  category: 'brand',
  colorable: false,
  name: 'creditmutuel',
  svg: creditmutuelSvg,
};
